import { render, staticRenderFns } from "./baseCom.vue?vue&type=template&id=6aee55a0&scoped=true"
import script from "./baseCom.vue?vue&type=script&lang=js"
export * from "./baseCom.vue?vue&type=script&lang=js"
import style0 from "../assets/css/base.css?vue&type=style&index=0&id=6aee55a0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aee55a0",
  null
  
)

export default component.exports